import { AppBand } from './AppBand.tsx';

/**
 * Static app-promo band (CMS-039). Placeable and phase-gatable like any section, but not
 * editable — renders the existing hardcoded AppBand as-is. AppBand already owns its full
 * background/section/padding, so it is rendered directly rather than wrapped in
 * CmsSectionShell (which would nest a second themed section around it). Theme/guitar are
 * required by the shared PageSection base but have no visual effect here.
 */
export function CmsAppSection() {
  return <AppBand />;
}
